import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.index-of.js";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};
/*
 * @Author       : Zhelin Cheng
 * @Date         : 2021-06-02 15:46:24
 * @LastEditors  : 程哲林
 * @LastEditTime : 2023-04-21 15:44:31
 * @FilePath     : /marketing-landing-fe/src/utils/sensors.ts
 * @Description  : 未添加文件描述
 */


import storage from '@woulsl/storage';
import session from '@woulsl/storage/session';
import sensors from '@woulsl-tools/sensors';
import { getAppVersion, qsParse, reportError } from '@/utils';
export function revertCustomState(val) {
  try {
    if (typeof val !== 'string' && val) {
      return String(val);
    }
  } catch (err) {
    reportError(err);
  }

  return val;
}
export function hasOwnProperty(obj, propName) {
  return (obj === null || obj === void 0 ? void 0 : obj.hasOwnProperty(propName)) || false;
}
export function channelSlice(channel) {
  var _a;

  try {
    if (!channel) {
      return {};
    }

    var channelStr = Array.isArray(channel) ? channel[0] : channel;
    var systemArr = ((_a = channelStr === null || channelStr === void 0 ? void 0 : channelStr.replace(/-.*$/, '')) === null || _a === void 0 ? void 0 : _a.split('_')) || [];
    return {
      business_ownership: systemArr[0],
      channel_name: systemArr[1],
      service_provider: systemArr[2],
      custom_state: systemArr[3]
    };
  } catch (e) {
    reportError(e);
  }

  return {};
}
export var saveSensData = function saveSensData(data) {
  try {
    storage.set('sensData', data, 60000);
    /* if (localStorage && typeof localStorage.setItem === 'function') {
      localStorage.setItem(
        'sensData',
        JSON.stringify({
          ...getSensData(),
          ...data
        })
      );
    } */
  } catch (e) {
    reportError(e);
  }
};
export var getSensData = function getSensData() {
  try {
    var data = storage.get('sensData') || {};
    var appVersion = getAppVersion();
    return __assign(__assign({}, data), {
      $app_version: appVersion || ''
    });
  } catch (e) {
    reportError(e);
  }

  return {};
};
export var saveAbTestSensData = function saveAbTestSensData(data) {
  try {
    session.set('abTestSensData', data);
  } catch (e) {
    reportError(e);
  }
};
export var getAbTestSensData = function getAbTestSensData() {
  try {
    return session.get('abTestSensData') || {};
  } catch (e) {
    reportError(e);
  }

  return {};
};
export var sensClickInitiative = function sensClickInitiative(val) {
  if (val === void 0) {
    val = {};
  }

  try {
    var parsed = qsParse();
    var channel = parsed.channel || '';
    var values = val || {};
    var channelNo = (values === null || values === void 0 ? void 0 : values.channelNo) || parsed.channelNo || '';

    if (hasOwnProperty(values, 'custom_state')) {
      values.custom_state = revertCustomState(values.custom_state);
    }

    if (values) {
      delete values.channelNo;
    }

    sensors.track('$WebClick', __assign(__assign(__assign(__assign(__assign(__assign({}, sensors.getPresetProperties()), {
      url_id: parsed.linkId || ''
    }), getSensData()), getAbTestSensData()), {
      channel: channel,
      channel_no: channelNo
    }), values));
  } catch (e) {
    reportError(e);
  }
};
export var sensClick = function sensClick(e) {
  try {
    // e.persist();
    var ele = e.currentTarget;
    var newValues = {};

    for (var _i = 0, _a = Object.entries(ele.dataset); _i < _a.length; _i++) {
      var _b = _a[_i],
          key = _b[0],
          val = _b[1];

      if (key.includes('element')) {
        newValues["$".concat(key)] = val;
      } else if (key === 'material_ids') {
        newValues[key] = val === null || val === void 0 ? void 0 : val.toString().split(',');
      } else {
        newValues[key] = val;
      }
    }

    sensClickInitiative(newValues);
  } catch (er) {
    reportError(er);
  }
};
var timer = null;
export var sensAutoTrack = function sensAutoTrack(val) {
  if (val === void 0) {
    val = {};
  }

  try {
    var parsed_1 = qsParse();
    var channel_1 = parsed_1.channel || '';
    var values_1 = val || {};
    var channelNo_1 = (values_1 === null || values_1 === void 0 ? void 0 : values_1.channelNo) || parsed_1.channelNo || '';

    if (hasOwnProperty(values_1, 'custom_state')) {
      values_1.custom_state = revertCustomState(values_1.custom_state);
    }

    if (values_1) {
      delete values_1.channelNo;
    }

    clearTimeout(timer);
    timer = setTimeout(function () {
      sensors.quick('autoTrack', __assign(__assign(__assign(__assign({
        activity_id: parsed_1.actId || '',
        channel: channel_1,
        channel_no: channelNo_1
      }, channelSlice(channel_1)), getSensData()), getAbTestSensData()), values_1));
      timer = null;
    }, 150);
  } catch (e) {
    reportError(e);
  }
};
export var sensElementView = function sensElementView(val) {
  if (val === void 0) {
    val = {};
  }

  try {
    var parsed = qsParse();
    var channel = parsed.channel || '';
    var baseData = getSensData();
    var values = val || {};
    var channelNo = (values === null || values === void 0 ? void 0 : values.channelNo) || parsed.channelNo || '';

    if (hasOwnProperty(values, 'custom_state')) {
      values.custom_state = revertCustomState(values.custom_state);
    }

    if (values) {
      delete values.channelNo;
    }

    sensors.track('ElementView', __assign(__assign(__assign(__assign({}, baseData), getAbTestSensData()), {
      activity_id: parsed.actId || baseData.activity_id || '',
      channel: channel,
      channel_no: channelNo
    }), values));
  } catch (e) {
    reportError(e);
  }
};
export var sensPageView = function sensPageView(val) {
  if (val === void 0) {
    val = {};
  }

  try {
    var parsed = qsParse();
    var channel = parsed.channel || '';
    var baseData = getSensData();
    var values = val || {};
    var channelNo = (values === null || values === void 0 ? void 0 : values.channelNo) || parsed.channelNo || '';

    if (hasOwnProperty(values, 'custom_state')) {
      values.custom_state = revertCustomState(values.custom_state);
    }

    if (values) {
      delete values.channelNo;
    }

    sensors.track('$pageview', __assign(__assign(__assign(__assign({}, baseData), getAbTestSensData()), {
      activity_id: parsed.actId || baseData.activity_id || '',
      channel: channel,
      channel_no: channelNo
    }), values));
  } catch (e) {
    reportError(e);
  }
};
export var sensVideoPlay = function sensVideoPlay(event, values) {
  if (values === void 0) {
    values = {};
  }

  try {
    sensors.track(event, values);
  } catch (e) {
    reportError(e);
  }
};
export var sensLongPress = function sensLongPress(val) {
  if (val === void 0) {
    val = {};
  }

  try {
    var values = val;

    if (hasOwnProperty(values, 'custom_state')) {
      values.custom_state = revertCustomState(values.custom_state);
    }

    sensors.track('LongPressQrCode', values);
  } catch (e) {
    reportError(e);
  }
}; // 自定义事件埋点

export var customFbTrack = function customFbTrack(eventName, values) {
  if (values === void 0) {
    values = {};
  }

  try {
    var channel = qsParse().channel;

    if (fbq && (channel === null || channel === void 0 ? void 0 : channel.indexOf('BJTF_Facebook_')) > -1) {
      return fbq('trackCustom', eventName, __assign({}, values));
    } // 公共数据

  } catch (error) {
    console.log(error);
  }

  return null;
};
export var Exposure = function Exposure(ele, option) {
  var parsed = qsParse();
  var channel = parsed.channel || '';
  var channelNo = parsed.channelNo || '';

  try {
    if (window.sensorsExpoSure) {
      window.sensorsExpoSure.addExposureView(ele, {
        eventName: 'ElementView',
        config: {
          area_rate: 0.5,
          stay_duration: 2,
          repeated: false
        },
        properties: __assign(__assign(__assign(__assign(__assign(__assign({}, sensors.getPresetProperties()), {
          url_id: parsed.linkId || ''
        }), getSensData()), getAbTestSensData()), {
          channel: channel,
          channel_no: channelNo
        }), option !== null && option !== void 0 ? option : {})
      });
    }
  } catch (error) {
    console.log(error);
  }
};
export var exposureModule = function exposureModule($el, moduleData) {
  try {
    if ($el && moduleData) {
      var module_1 = moduleData.module;
      var moduleId = (module_1 !== null && module_1 !== void 0 ? module_1 : {}).moduleId;
      Exposure($el, {
        material_type: moduleId,
        c_element_name: '投放落地页_组件浏览'
      });
    }
  } catch (error) {
    console.log(error);
  }
};